<template>
  <div id="dashboard">
    <FilterFactsheet
      :year="true"
      :region="true"
      :markets="true"
      :dataSource="$t('filter.sourceHesta')"
      @refresh="setParams"
    />
    <loading v-if="loading" />
    <b-row v-else>
      <b-col>
        <GChartCard
          v-if="this.gchart.data"
          title="Factsheet"
          :data="this.gchart.data"
          :options="this.gchart.options"
          :key="this.params.indicator"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DashboardMixins from "@/mixins/api/dashboard";
import FilterFactsheet from "@/components/utils/filterbar/filterFactsheets.vue";
import ChartCard from "@/components/dashboard/ChartCard";
import GChartCard from "@/components/dashboard/GChartCard";

export default {
  name: "Factsheets",
  mixins: [DashboardMixins],
  components: {
    FilterFactsheet,
    ChartCard,
    GChartCard,
  },
  data() {
    return {
      factsheetChart: {
        title: "Factsheet",
        options: {
          plotOptions: {
            bar: {
              dataLabels: {
                position: "top", // top, center, bottom
              },
            },
          },
          chart: {
            id: "hesta_factsheet",
          },
          xaxis: {
            categories: [],
          },
          yaxis: null,
          dataLabels: {
            enabled: true,
            enabledOnSeries: [0],
            offsetY: -15,
            style: {
              colors: ["#000"],
              fontSize: ".7rem",
            },
            formatter: function (val) {
              return val > 0
                ? val.toLocaleString("fr-CH", {
                    maximumFractionDigits: 2,
                    miniumFractionDigits: 0,
                  })
                : "0";
            },
          },
          colors: ["#0984e3", "#2980b9", "#e74c3c", "#c0392b"],
          tools: {
            download: true,
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
          },
        },
        type: "line",
        data: [
          {},
          {
            name: this.$t("hesta.graph.previousYear"),
            type: "line",
            data: null,
          },
        ],
      },
      gchart: {
        data: null,
        options: {
          height: 300,
          hAxis: {
            format: "####",
            showTextEvery: 1,
            gridlines: {
              count: 9,
            },
          },
          vAxis: {
            minValue: 0,
          },
          series: {
            0: { targetAxisIndex: 0, color: "#3366cc" },
            1: { type: "line", targetAxisIndex: 0, color: "#3366cc" },
            2: { targetAxisIndex: 0, color: "#dc3912" },
            3: { type: "line", targetAxisIndex: 0, color: "#dc3912" },
          },
          legend: { position: "top", maxLines: 5 },
          allowHtml: true,
        },
      },
    };
  },
  methods: {
    setParams(newParams) {
      this.params = newParams;
      this.refreshFactsheet();
    },
  },
};
</script>

<style></style>
